import * as React from 'react';
import styled from 'styled-components';
import locale from 'date-fns/locale/de';
import { format } from 'date-fns';

import { Card, Body, ButtonBase, BonuscoinIcon, InfoIcon, Popover, Button } from '../material-ui';
import { VoucherIcon } from './VoucherIcon';

const formatDate = (date) => format(date, 'D. MMM YYYY', { locale });

const Wrapper = styled(Card)`
	position: relative;
	margin: 0.5rem;
	width: 21rem;
	height: 6rem;
	cursor: ${(p) => (p.onClick ? 'pointer' : 'auto')};
	background: lightgray;
	display: flex;
	flex-flow: row wrap;
	overflow: visible !important;
`;

const ButtonWrapper = styled(ButtonBase)`
	opacity: ${(p) => (p.disabled ? 0.5 : 1)};
	height: 6rem;
`;

const TextWrapper = styled.div`
	width: 10rem;
	padding: 0.5rem 1rem;
	display: flex;
	align-items: center;
	justify-content: start;
`;

const StyledTitle = styled(Body)`
	font-weight: 500 !important;
	text-align: left;
`;

const PriceWrapper = styled.div`
	width: 5rem;
	height: 6rem;
	background-color: ${(p) => p.theme.palette.grey[300]};
	display: flex;
	flex-flow: column;
	align-items: center;
	justify-content: center;
	color: ${(p) => p.theme.palette.action.active};
	font-size: 1.2rem;
	font-weight: 800;
	line-height: 2rem;
	letter-spacing: -1px;
	padding-top: 1rem;
	svg {
		color: ${(p) => p.theme.palette.action.active};
		font-size: 1.8rem !important;
	}
`;

const InfoIconWrapper = styled.div`
	position: absolute;
	width: 1.75rem;
	height: 1.75rem;
	top: -0.5rem;
	right: -0.5rem;
	cursor: pointer;
	display: flex;
	justify-content: flex-end;
	border-radius: 1rem;
	&:hover {
		background-color: ${(p) => p.theme.palette.action.selected};
	}
	svg {
		font-size: 1.75rem !important;
		color: ${(p) => p.theme.palette.action.active};
		&:hover,
		&:focus,
		&:active {
			color: ${(p) => p.theme.palette.primary.main};
		}
	}
	&.light svg {
		opacity: 0.7;
	}
`;

const InfoBox = styled(Popover).attrs({
	anchorOrigin: { vertical: 'top', horizontal: 'right' },
	transformOrigin: { vertical: 'bottom', horizontal: 'right' },
})``;

const InfoBoxContent = styled.div`
	padding: 2rem;
	width: 21rem;
`;

const InfoText = styled(Body)`
	padding-bottom: 0.5rem;
	&.bold {
		font-weight: 700 !important;
	}
`;

const InfoButtonWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	margin: 1rem 1rem 0 0;
`;

export class VoucherCard extends React.Component {
	state = { showInfo: false };
	anchor = null;

	setAnchorRef = (node) => {
		this.anchor = node;
	};

	handleClick = () => {
		const { onClick, ...voucher } = this.props;
		if (onClick) onClick(voucher);
	};

	handleHideInfo = () => this.setState({ showInfo: false });
	handleClickInfo = (e) => {
		e.stopPropagation();
		this.setState({ showInfo: true });
	};

	render = () => {
		const {
			title,
			iconName,
			price,
			description,
			maxQuantityPerPerson,
			remainingCapacity,
			bookableUntil,
			redeemableUntil,
			available,
			redeemedDatetime,
			createdDatetime,
			valid,
		} = this.props;
		return (
			<Wrapper>
				<ButtonWrapper
					buttonRef={this.setAnchorRef}
					onClick={this.handleClick}
					disabled={!available}
				>
					<VoucherIcon name={iconName} />
					<TextWrapper>
						<StyledTitle>{title}</StyledTitle>
					</TextWrapper>
					<PriceWrapper>
						<BonuscoinIcon />
						{price}
					</PriceWrapper>
				</ButtonWrapper>
				<InfoIconWrapper onClick={this.handleClickInfo} className={!available && 'light'}>
					<InfoIcon />
				</InfoIconWrapper>
				<InfoBox
					open={Boolean(this.state.showInfo)}
					anchorEl={this.anchor}
					onClose={this.handleHideInfo}
				>
					<InfoBoxContent>
						<InfoText className="bold">{title}</InfoText>
						<InfoText>{description}</InfoText>
						<InfoText>Preis: {price}</InfoText>
						{maxQuantityPerPerson && <InfoText>Pro Person: {maxQuantityPerPerson}</InfoText>}
						{remainingCapacity && <InfoText>Verfügbar: {remainingCapacity}</InfoText>}
						{bookableUntil && <InfoText>Buchbas bis: {formatDate(bookableUntil)}</InfoText>}
						{redeemableUntil && <InfoText>Einlösbar bis: {formatDate(redeemableUntil)}</InfoText>}
						{redeemedDatetime && <InfoText>Eingelöst am: {formatDate(redeemedDatetime)}</InfoText>}
						{createdDatetime && <InfoText>Gekauft am: {formatDate(createdDatetime)}</InfoText>}
						{valid === false && <InfoText>Ungültiger Gutschein</InfoText>}
						<InfoButtonWrapper>
							<Button size="small" onClick={this.handleHideInfo}>
								Abbrechen
							</Button>
							<Button
								variant="outlined"
								size="small"
								onClick={this.handleClick}
								disabled={!available}
							>
								Auswählen
							</Button>
						</InfoButtonWrapper>
					</InfoBoxContent>
				</InfoBox>
			</Wrapper>
		);
	};
}



// WEBPACK FOOTER //
// ./src/components/VoucherCard.js